export const setInfoMessage = (payload: any) => {
    const { transmitFailed, transferReceived } = payload;
    if(transmitFailed) {
        return "Transfer failed";
    } else if(!transferReceived) {
        return "Transfer in progress"; 
    } else {
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/components/TransferTooltip/utils/setInfoMessage.ts